module.exports = "<div class=\"modal-footer\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"